class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // Open on hover only where a real mouse is used; touch devices keep tap-to-open.
    this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.querySelectorAll('details').forEach((details) => this.bindHover(details));
  }

  bindHover(details) {
    const trigger = details.parentElement;
    const summary = details.querySelector('summary');
    let closeTimer;

    trigger.addEventListener('mouseenter', () => {
      if (!this.hoverQuery.matches) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Short delay so the pointer can cross the gap between the menu item and its dropdown.
    trigger.addEventListener('mouseleave', () => {
      if (!this.hoverQuery.matches) return;
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 200);
    });

    // A mouse click on an already hover-opened item would otherwise close it; keyboard toggling is unchanged.
    summary.addEventListener('click', (event) => {
      if (this.hoverQuery.matches && event.detail > 0 && details.open) event.preventDefault();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
